var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.refresh}},[(_vm.loading)?_c('a-icon',{attrs:{"type":"sync","spin":""}}):_c('a-icon',{attrs:{"type":"sync"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }